(function () {
  'use strict';

  async function onAddBundleClick(event) {
    const button = event.currentTarget;
    if (button.classList.contains('is-loading')) return;

    let items;
    try {
      items = JSON.parse(button.dataset.bundleItems || '[]');
    } catch (error) {
      console.error('Bogo bundle JSON error:', error);
      return;
    }

    if (!Array.isArray(items) || items.length === 0) return;

    const loader = button.querySelector('[data-bogo-bundle-cta-loader]');

    button.classList.add('is-loading');
    button.disabled = true;
    if (loader) loader.hidden = false;

    // cart-drawer subscribes to PUB_SUB_EVENTS.cartAdd itself and renders
    // whatever sections come with it (see cart-drawer.js connectedCallback /
    // renderContents) — same flow product-form.js and reel-carousel.js use
    // for the general product card and reel add-to-cart buttons, so this
    // bundle button opens the drawer and updates the cart count the same way.
    const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer?.openCart();

    try {
      const sectionId = cartDrawer?.dataset?.sectionId || 'cart-drawer';

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items,
          sections: [sectionId],
          sections_url: window.location.pathname,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw data;

      publish(PUB_SUB_EVENTS.cartAdd, {
        source: 'bogo-most-bought-together',
        sections: data.sections,
      });
    } catch (error) {
      console.error('Bogo bundle cart error:', error);
    } finally {
      button.classList.remove('is-loading');
      button.disabled = false;
      if (loader) loader.hidden = true;
    }
  }

  function initBogoMostBoughtTogether(section) {
    if (!section || section.dataset.initialized === 'true') return;

    section.querySelectorAll('[data-bogo-bundle-add]').forEach((button) => {
      button.addEventListener('click', onAddBundleClick);
    });

    section.dataset.initialized = 'true';
  }

  function initAll() {
    document.querySelectorAll('.bogo-most-bought-together:not([data-initialized="true"])').forEach(initBogoMostBoughtTogether);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.bogo-most-bought-together');
    if (section) initBogoMostBoughtTogether(section);
  });
})();
